<script setup>
import { useRouter } from "vue-router";
import AppDataTable from "@/components/AppDataTable.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { useResourceList } from "@/composables/useResourceList";
import { formatDate, toDate } from "@/lib/date";
import { fetchPromotions, deletePromotion } from "./api";

const router = useRouter();
const columns = [
  { key: "title",     label: "Title",      sortable: true },
  { key: "startDate", label: "Start Date" },
  { key: "endDate",   label: "End Date" },
  { key: "actions",   label: "Actions",    align: "end", width: "150px" },
];
const { rows, loading, error, pendingDelete, deleting, load, askDelete, confirmDelete } =
  useResourceList({
    fetch: fetchPromotions,
    remove: deletePromotion,
    mapRow: (p) => ({ id: p._id, title: p.name ?? p.title ?? "—", startDate: formatDate(p.dateTimeStart ?? p.startDate), endDate: formatDate(p.dateTimeEnd ?? p.endDate), _sortDate: toDate(p.updatedDateTime ?? p.dateTimeStart ?? p.startDate)?.getTime() ?? 0 }),
    sort: (a, b) => b._sortDate - a._sortDate,
  });
</script>

<template>
  <section>
    <div class="d-flex align-center justify-space-between mb-4 gap-3 flex-wrap">
      <h1 class="text-h5">Manage Promotions</h1>
      <div class="d-flex gap-2">
        <VBtn variant="tonal" @click="load">Refresh</VBtn>
        <VBtn @click="router.push({ name: 'promotions-new' })">Add Promotion</VBtn>
      </div>
    </div>
    <VAlert v-if="error" type="error" closable class="mb-4" @click:close="error = ''">{{ error }}</VAlert>
    <AppDataTable :columns="columns" :rows="rows" :loading="loading" row-key="id" searchable search-placeholder="Search promotions…" empty-text="No promotions yet.">
      <template #cell-actions="{ row }">
        <VBtn size="small" variant="text" @click.stop="router.push({ name: 'promotions-edit', params: { id: row.id } })">Edit</VBtn>
        <VBtn size="small" color="error" variant="text" @click.stop="askDelete(row)">Delete</VBtn>
      </template>
    </AppDataTable>
    <ConfirmDialog :model-value="pendingDelete !== null" title="Delete promotion?" :message="`Delete &quot;${pendingDelete?.title || 'this promotion'}&quot;?`" :loading="deleting" @update:model-value="pendingDelete = null" @confirm="confirmDelete" />
  </section>
</template>
